// extracted by mini-css-extract-plugin
export var h1 = "titles-module--h1--21256";
export var h2 = "titles-module--h2--78d94";
export var h3 = "titles-module--h3--fd2e8";
export var h4 = "titles-module--h4--3488d";
export var sub = "titles-module--sub--1bbc3";